import React from 'react';
import CTAButton from './Button';
import { FaArrowRight } from 'react-icons/fa';
import { TypeAnimation } from 'react-type-animation';

const CodeBlocks = ({
    position, heading, subHeading, ctaButton1, ctaButton2, codeBlock, backgroundGradient, codeColor
}) => {
    return (
        <div className={`flex ${position} flex-col lg:my-20 my-10 justify-between gap-10`}>
            <div className='lg:w-[50%] w-full flex flex-col gap-8'>
                <div className='md:text-4xl text-3xl font-semibold'>{heading}</div>
                <div className='text-richblack-300 text-[1.1rem] font-bold '>{subHeading}</div>
                <div className='flex gap-7 mt-7'>
                    <CTAButton active={ctaButton1.active} linkTo={ctaButton1.linkTo}>
                        <div className='flex gap-2 items-center'>
                            {ctaButton1.btnText}
                            <FaArrowRight />
                        </div>
                    </CTAButton>
                    <CTAButton active={ctaButton2.active} linkTo={ctaButton2.linkTo}>
                        {ctaButton2.btnText}
                    </CTAButton>
                </div>
            </div>
            <div className='code-border text-[13px] flex h-fit flex-row w-[100%] py-4 lg:w-[470px] overflow-hidden'>
                <div className='text-center flex flex-col w-[10%] text-richblack-400 font-inter font-bold leading-6'>
                    {[...Array(13)].map((_, index) => (
                        <p key={index}>{index + 1}</p>
                    ))}
                </div>
                <div className={`relative w-[90%] flex flex-col gap-2 font-bold font-mono ${codeColor} pr-2 leading-6 `}>
                    <div className={`${backgroundGradient} absolute`}></div>
                    <TypeAnimation
                        sequence={[codeBlock, 3000, '']}
                        repeat={Infinity}
                        cursor={true}
                        style={{
                            whiteSpace: 'pre-line',
                            display: 'block'
                        }}
                        omitDeletionAnimation={true}
                    />
                </div>
            </div>
        </div>
    )
}

export default CodeBlocks;